import { PatientExerciseSchema } from '@/jsonapi/PatientExercise'

export interface ExerciseState {
  exercises: PatientExerciseSchema[]
  autosaveTimer: number | null
  loading: LoadingTypes
}

export enum LoadingTypes {
  INITIAL,
  FULL_SCREEN,
  PARTIAL,
}
